<template>
	<div class="filter caption-2">
		<p class="">Filter</p>
		<div class="filter_list-scroll" :class="scrollClass">
			<ul class="filter_list" ref="list">
				<template v-for="option in filterOptions" >
					<li :key="option.key" v-if="hasFilters(option)">
						<filters-dropdown
							:options="option"
							:selected-filters="value[option.key]"
							@update-filter="updateFilters"
						/>
					</li>
				</template>
			</ul>
		</div>
	</div>
</template>
<script>
import throttle from 'lodash.throttle';
import FiltersDropdown from './FiltersDropdown';

let timerId = null;
export default {
	name: 'FiltersList',
	components: {FiltersDropdown},
	props: {
		filterOptions: {
			type: Object,
			default() {
				return {};
			},
		},
		value: {
			type: Object,
		},
	},
	mounted() {
		this.initListScroll();
		this.listScroll(this.$refs.list);
	},
	beforeDestroy() {
		this.removeListScroll();
	},
	data: () => ({
		showRightOverlay: false,
		showRightArrow: false,
		showLeftOverlay: false,
	}),
	computed: {
		scrollClass() {
			return {
				'filter_list-scroll--prev': this.showLeftOverlay,
				'filter_list-scroll--next': this.showRightOverlay,
				'filter_list-scroll--next-arrow': this.showRightArrow,
			};
		},
	},
	methods: {
		updateFilters({filterGroupKey, filterSelect}) {
			this.$emit('input', {
				...this.value,
				[filterGroupKey]: filterSelect,
			});
		},
		initListScroll() {
			this.$refs.list.addEventListener('scroll', throttle(this.listScroll, 33));
		},
		listScroll(event) {
			const {target: ctx} = event;
			if (!ctx) return;
			const {scrollWidth, scrollLeft, offsetWidth} = ctx;
			this.showRightOverlay = !!(offsetWidth - scrollWidth + scrollLeft);
			this.showLeftOverlay = !!scrollLeft;
			this.showRightArrow = !scrollLeft;
		},
		removeListScroll() {
			this.$refs.list.removeEventListener('scroll', throttle(this.listScroll, 33));
		},
		hasFilters(option) {
			return option.filterGroup.filters.length > 0
		}
	},
};
</script>
<style lang="scss" scoped>
.filter {
	position: relative;
	z-index: 2;
	padding: 24px 16px 0;
	margin-bottom: -10px;
	@media (min-width: $mobile + 1) and (max-width: 992px) {
		margin: 0;
		padding: 24px 24px 10px;
	}
	@media (min-width: 993px) {
		margin: 0;
		padding: 24px 16px 16px;
	}
}
$filters-gap: 0.5rem;
.filter_list {
	@include flexRow;
	margin: 0;
	padding: 0 0 10px;
	gap: $filters-gap;
	list-style: none;
	overflow: auto;
	overscroll-behavior: none;
	@media (min-width: $mobile) {
		padding-bottom: 0;
		flex-wrap: wrap;
		overflow: visible;
	}
	@supports not (gap: 1rem) {
		li + li {
			margin-left: $filters-gap;
		}
	}
}
.filter_list-scroll {
	position: relative;
	&:before,
	&:after {
		content: '';
		position: absolute;
		top: 0;
		bottom: 0;
		width: 40px;
		z-index: 1;
		pointer-events: none;
		opacity: 0;
		transition: opacity 0.3s;
	}
	&:before {
		left: 0;
		background: linear-gradient(270deg, rgba($color-extra-light-grey, 0), $color-extra-light-grey);
	}
	&:after {
		content: '\e912';
		font-family: 'luna-icons' !important;
		color: transparent;
		transition: opacity 0.3s, color 0.3s;
		font-size: 30px;
		line-height: 1;
		display: flex;
		align-items: center;
		justify-content: flex-end;
		right: -10px;
		width: 50px;
		background: linear-gradient(90deg, rgba($color-extra-light-grey, 0), $color-extra-light-grey 40px);
	}
	@media (min-width: $mobile) {
		&:before,
		&:after {
			display: none;
		}
	}
}
.filter_list-scroll--prev {
	&:before {
		opacity: 1;
	}
}
.filter_list-scroll--next {
	&:after {
		opacity: 1;
	}
}
.filter_list-scroll--next-arrow {
	&:after {
		color: $color-blue;
	}
}
</style>
